import { render, staticRenderFns } from "./ServiceProvider.vue?vue&type=template&id=79fc7172&scoped=true&"
import script from "./ServiceProvider.vue?vue&type=script&lang=js&"
export * from "./ServiceProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc7172",
  null
  
)

export default component.exports